// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upgrade-banner[data-v-8aaed206] {\n  font-size: 13px;\n}\n.upgrade-banner[data-v-8aaed206] .v-alert__border {\n  border-width: 1px;\n}\n.upgrade-banner[data-v-8aaed206] .v-alert__icon.v-icon {\n  -ms-flex-item-align: center;\n      align-self: center;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
